import { useEffect, useState } from "react";
import api, { fileUrl } from "./api";

let cached = null;
let pending = null;

export function useBrand() {
  const [brand, setBrand] = useState(cached);
  useEffect(() => {
    if (cached) return;
    if (!pending) {
      pending = api.get("/public/brand").then((r) => {
        cached = r.data;
        return cached;
      });
    }
    pending.then((b) => setBrand(b));
  }, []);
  return brand;
}

let instCached = null;
let instPending = null;

export function useInstitutional() {
  const [inst, setInst] = useState(instCached);
  useEffect(() => {
    if (instCached) return;
    if (!instPending) {
      instPending = api.get("/public/institutional").then((r) => {
        instCached = r.data;
        return instCached;
      });
    }
    instPending.then((v) => setInst(v));
  }, []);
  return inst;
}

export function invalidateInstitutional() {
  instCached = null;
  instPending = null;
}

export function brandLogo(brand, variant = "primary") {
  if (!brand) return null;
  const path = variant === "light" ? brand.logo_light_path : brand.logo_path;
  return path ? fileUrl(path) : null;
}

// UTM & referrer capture
const STORAGE_KEY = "azu_traffic_source";

export function captureTrafficSourceIfAny() {
  try {
    const url = new URL(window.location.href);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = url.searchParams.get(k);
      if (v) utm[k] = v;
    });
    const existing = getTrafficSource();
    // Only capture if new UTM params present OR nothing stored yet
    if (Object.keys(utm).length > 0 || !existing) {
      const referrer = document.referrer || "";
      const source = {
        ...utm,
        referrer: referrer && !referrer.startsWith(window.location.origin) ? referrer : "direct",
        landing_page: window.location.pathname,
        captured_at: new Date().toISOString(),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(source));
    }
  } catch {
    // no-op
  }
}

export function getTrafficSource() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
